<template>
  <div>
    <headerNav title="我的钱包" />
    <div class="mz-main">
      <div style="text-align:center">
        <div class="mz-main-tit" :style="{color:$abctheme.basefzcolor}">{{title}}</div>
        <div>
          <span class="mz-main-pp" :style="{color:$abctheme.basefzcolor}">￥</span>
          <span class="mz-main-price" :style="{color:$abctheme.basefzcolor}">{{largeLoans}}</span>
        </div>
        <van-button class="vbut setbtns" :color="$abctheme.basecolor" icon="plus" type="info" round @click="toRecharge(type)">充值</van-button>
        <van-button class="vbut setbtns" :color="$abctheme.basecolor" icon="plus" type="info" round @click="goto(type)">明细查询</van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      type:0,
      title:'大货账户金额',
      largeLoans: 0,
    };
  },
  created() {
    var options= this.$route.query;
    if(options)
    {
      this.type=Number.parseInt(options.ctype);
      if(this.type==1)
      {
           this.title='物料账户金额';
      }
    }

    this.ajax.post("/api/services/app/PhoneUser/QueryUserInfo").then((u) => {
      this.abp.userInfo = u.result;
      this.largeLoans = this.abp.userInfo.largeLoans;
      if(this.type==1)
      {
          this.largeLoans = this.abp.userInfo.accessoriesLoans;
      }
    });
  },
  methods: {
    toRecharge(e) {
      this.$router.push({
        path: "/rechargemoney",
        query: { rechargeType: e },
      });
    },
    goto(e)
    {
      var url='/largeloancostlog';
      if(e==1)
      {
        url='/assistcostlog';
      }
      this.$router.push({
        path: url
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.mz-main {
  position: relative;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 1px 1px 4px #bbb;
  text-align: center;
  padding: 50px 0;
  font-size: 25px;
  margin: 20px 10px 80px 10px;
}
.mz-main-tit {
  font-size: 25px;
}
.mz-main-pp {
  font-size: 50px;
}

.mz-main-price {
  font-size: 40px;
  color:red;
}
.vbut {
  width: 70%;
  margin-top: 20px;
}
</style>


